import styled from '@emotion/styled'

export const StatusTag = styled.div<{ color: string; size?: 'small' | 'default' }>`
  &,
  & div {
    font-size: ${({ size }) => (size === 'small' ? '11px' : '13px')};
  }
  padding: 4px 6px;
  border-radius: 4px;
  color: white;
  background-color: ${({ color }) => color};
  display: flex;
  align-items: center;
`
